module.exports = __webpack_public_path__ + "media/ru_ru_s1_Artem.c789dd15.oga";